export default __webpack_public_path__ + "static/cta-a-escola-80cce66a9f834e2db56e8d9c27ac1d3c.png";